import { PerspectiveCamera } from 'three';
import * as THREE from "three";



function createCamera() {
    const camera = new PerspectiveCamera(
        // camera = new THREE.OrthographicCamera(
        45,
        window.innerWidth / window.innerHeight
    );
    // camera.lookAt(new THREE.Vector3(0, 0, 0));
    return camera;
}

export { createCamera };
